import React from 'react';
import { Link } from 'react-router-dom';

// Import the logo
import atsLogo from '../../assets/img/ATS.jpg';

const MobileMenu = ({ isOpen, onClose }) => {
    return (
        <div
            className={`mobile-menu-wrapper ${isOpen ? 'active' : ''}`}
            style={{
                position: 'fixed',
                top: 0,
                left: isOpen ? '0' : '-100%',
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                zIndex: 9999,
                transition: 'left 0.3s ease-in-out',
                overflow: 'hidden'
            }}
        >
            <div
                className="mobile-menu-area"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '80%',
                    maxWidth: '300px',
                    height: '100%',
                    backgroundColor: '#fff',
                    padding: '20px',
                    textAlign: 'center',
                    boxShadow: '2px 0 10px rgba(0,0,0,0.3)',
                    overflowY: 'auto'
                }}
            >
                {/* Logo and Close Button */}
                <div
                    className="mobile-logo"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '40px',
                        paddingBottom: '20px',
                        borderBottom: '1px solid #eee'
                    }}
                >
                    <Link to="/" onClick={onClose}>
                        <img
                            src={atsLogo}
                            alt="Ascend Travel Solutions"
                            style={{
                                maxHeight: '50px',
                                width: 'auto'
                            }}
                        />
                    </Link>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            color: '#333',
                            cursor: 'pointer',
                            padding: '5px',
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'background-color 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f0f0f0';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                        }}
                    >
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                {/* Navigation Menu */}
                <nav className="mobile-menu">
                    <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        textAlign: 'left'
                    }}>
                        {[
                            { path: '/', label: 'Home' },
                            { path: '/services', label: 'Our Services' },
                            { path: '/about', label: 'About Us' },
                            { path: '/enquiry', label: 'Enquiry' },
                            { path: '/contact', label: 'Reach Us' }
                        ].map((item, index) => (
                            <li key={index} style={{
                                marginBottom: '10px',
                                borderBottom: '1px solid #f5f5f5'
                            }}>
                                <Link
                                    to={item.path}
                                    onClick={onClose}
                                    style={{
                                        display: 'block',
                                        padding: '15px 20px',
                                        color: '#333',
                                        textDecoration: 'none',
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        transition: 'all 0.3s ease',
                                        borderRadius: '5px'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f7bd34ff';
                                        e.target.style.color = '#fff';
                                        e.target.style.paddingLeft = '25px';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#333';
                                        e.target.style.paddingLeft = '20px';
                                    }}
                                >
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* Additional Mobile Menu Info */}
                <div style={{
                    marginTop: '40px',
                    padding: '20px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '10px',
                    textAlign: 'left'
                }}>
                    <div style={{ marginBottom: '15px' }}>
                        <h4 style={{
                            fontSize: '14px',
                            color: '#f7bd34ff',
                            margin: '0 0 5px 0',
                            fontWeight: '600'
                        }}>
                            <i className="fas fa-phone" style={{ marginRight: '8px' }}></i>
                            Call Us
                        </h4>
                        <a
                            href="tel:+123456789"
                            style={{
                                color: '#333',
                                textDecoration: 'none',
                                fontSize: '14px'
                            }}
                        >
                            83174 47895
                        </a>
                    </div>
                    <div>
                        <h4 style={{
                            fontSize: '14px',
                            color: '#f7bd34ff',
                            margin: '0 0 5px 0',
                            fontWeight: '600'
                        }}>
                            <i className="fa-solid fa-envelope" style={{ marginRight: '8px' }}></i>
                            Email Us
                        </h4>
                        <a
                            href="mailto:info@example.com"
                            style={{
                                color: '#333',
                                textDecoration: 'none',
                                fontSize: '14px'
                            }}
                        >
                             Booking@ascendtravelsolutions.in
                        </a>
                    </div>
                </div>
            </div>

            {/* Overlay Click to Close */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: '80%',
                    width: '20%',
                    height: '100%',
                    cursor: 'pointer'
                }}
                onClick={onClose}
            ></div>
        </div>
    );
};

export default MobileMenu;